// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox-module--checkbox--1_aYF"};